import PropTypes from "prop-types";
import propTypes from "../../../../../constants/propTypes";
import { getDataComponentFlattenedRequestState } from "../../../../../reducers/dataComponentReducer";
import { openModalDialog } from "../../../../../actions/layoutActions";
import withRenderOnPermissionActive from "../../../../hocs/withRenderOnPermissionActive";
import { connect } from "react-redux";
import TemplateCategoryPage from "./TemplateCategoryPage";
import React, { useCallback } from "react";
import { getResourcesV2 } from "../../../../../utils/bluechipUtils";
import { SCOPES_SELECT } from "../../../../../constants/DataComponents";
import useScope from "../../../../hooks/useScope";

export const templateCategoryComponentId = "TemplateCategoriesGrid";

const TemplateCategoryContainer = ({
  dataComponent,
  scopes,
  openModalDialog,
}) => {
  const scope = useScope();

  const handleOpenCreateModal = useCallback(() => {
    openModalDialog(
      "Template Category",
      "CreateTemplateCategory",
      { instance: scope?.id ? { scopeId: scope.id } : {} },
      false
    );
  }, [openModalDialog, scope.id]);

  const handleOpenEditModal = useCallback(
    templateCategory => {
      openModalDialog(
        `Edit ${templateCategory.name}`,
        "CreateTemplateCategory",
        {
          instance: templateCategory,
        },
        false
      );
    },
    [openModalDialog]
  );

  const handleOpenDeleteModal = useCallback(
    ({ id, name }) => {
      openModalDialog(
        `Delete ${name}`,
        "StandardDelete",
        {
          id,
          title: name,
          dataComponentId: templateCategoryComponentId,
        },
        false
      );
    },
    [openModalDialog]
  );

  return (
    <TemplateCategoryPage
      dataComponent={dataComponent}
      scopes={scopes}
      onOpenCreateModal={handleOpenCreateModal}
      onOpenEditModal={handleOpenEditModal}
      onOpenDeleteModal={handleOpenDeleteModal}
    />
  );
};

TemplateCategoryContainer.propTypes = {
  dataComponent: propTypes.dataComponent,
  scopes: PropTypes.array,
  openModalDialog: PropTypes.func.isRequired,
};

export const mapStateToProps = state => {
  const scopesDataComponent = getDataComponentFlattenedRequestState(
    SCOPES_SELECT,
    state
  );

  return {
    dataComponent: getDataComponentFlattenedRequestState(
      templateCategoryComponentId,
      state
    ),
    scopes: getResourcesV2(scopesDataComponent, state) || [],
  };
};

export const mapDispatchToProps = {
  openModalDialog,
};

export default withRenderOnPermissionActive(
  connect(mapStateToProps, mapDispatchToProps)(TemplateCategoryContainer),
  ["edit-template-categories"]
);
